const {
    REACT_APP_BASENAME,
    REACT_APP_WORKSSOACE_NAME,
    REACT_APP_NAME_PROYECT,
    REACT_APP_LOCALSTORAGE_DATA_SECION,
    REACT_APP_PUBLIC_URL,
    REACT_APP_CLIEN_ID,
    REACT_APP_TITLE_PROYECT,
} = process.env;

export default {
    BASENAME: REACT_APP_BASENAME,
    PUBLIC_URL: REACT_APP_PUBLIC_URL,
    CLIENT_ID: REACT_APP_CLIEN_ID,
    CONFIG_MODULE: {
        LOCALSTORAGE_KEY: REACT_APP_LOCALSTORAGE_DATA_SECION || '',
        NAME_PROYECT: REACT_APP_NAME_PROYECT || '',
        TITLE_PROYECT: REACT_APP_TITLE_PROYECT || '',
        WORKSSOACE_NAME: REACT_APP_WORKSSOACE_NAME || '',
    },
};